var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeniedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.002 75.5H65.002V85.5H55.002V75.5ZM55.002 35.5H65.002V65.5H55.002V35.5ZM60.002 10.5C32.352 10.5 10.002 33 10.002 60.5C10.002 73.7608 15.2698 86.4785 24.6466 95.8553C29.2895 100.498 34.8015 104.181 40.8678 106.694C46.9341 109.207 53.4359 110.5 60.002 110.5C73.2628 110.5 85.9805 105.232 95.3573 95.8553C104.734 86.4785 110.002 73.7608 110.002 60.5C110.002 53.9339 108.709 47.4321 106.196 41.3658C103.683 35.2995 100 29.7876 95.3573 25.1447C90.7144 20.5017 85.2024 16.8188 79.1361 14.306C73.0698 11.7933 66.568 10.5 60.002 10.5ZM60.002 100.5C49.3933 100.5 39.2191 96.2857 31.7177 88.7843C24.2162 81.2828 20.002 71.1087 20.002 60.5C20.002 49.8913 24.2162 39.7172 31.7177 32.2157C39.2191 24.7143 49.3933 20.5 60.002 20.5C70.6106 20.5 80.7848 24.7143 88.2862 32.2157C95.7877 39.7172 100.002 49.8913 100.002 60.5C100.002 71.1087 95.7877 81.2828 88.2862 88.7843C80.7848 96.2857 70.6106 100.5 60.002 100.5Z",
    fill: "#D71C39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeniedIcon);
export default __webpack_public_path__ + "static/media/denied-icon.e01ae38fd96530e51d3f57771f2e8722.svg";
export { ForwardRef as ReactComponent };